import { YodaBorderRadius, YodaColors, YodaFontSize } from 'yoda-ui/yodaTheme';

export const TagStyle = {
  fontSize: YodaFontSize.small,
  fontWeight: 500,
  color: YodaColors.textSecondary,
  backgroundColor: YodaColors.gray1,

  borderRadius: YodaBorderRadius.xSmall,
  height: '25px',

  '& .MuiChip-label': {
    paddingLeft: '6px',
    paddingRight: '6px',
  },

  '& .MuiChip-deleteIcon': {
    width: '0.8em',
    height: '0.8em',
    color: YodaColors.textSecondary,
    opacity: 0.7,
    '&:hover': {
      opacity: 1,
    },
  },
};
